/* eslint-disable no-unneeded-ternary */
import { AxiosResponse } from 'axios';
import { format, startOfYear } from 'date-fns';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import api from '../../../services/api';
import { calculateAveragekpiByUnit } from '../../../utils/getChartsValues';
import { getKpisRequest, getKpisSuccess, getKpisFailure } from './actions';
import { ActionTypes, IkpisResponse } from './types';

type GetKpisRequest = ReturnType<typeof getKpisRequest>;

export function* getKpis({ payload }: GetKpisRequest): any {
  const { jwt, user, startDate, endDate, timescale } = payload.input;

  const unitsIds: string[] = [];
  user.units.map(unit => unitsIds.push(unit.id));

  const today = new Date();
  const firstDayOfYear = startDate
    ? startOfYear(startDate)
    : startOfYear(today);

  const start = startDate ? startDate : firstDayOfYear;
  const end = endDate ? endDate : today;

  const formattedStart = format(start, 'yyyy-MM-dd');
  const formattedEnd = format(end, 'yyyy-MM-dd');

  const response: AxiosResponse<IkpisResponse> = yield call(
    api.get,
    `/kpi/${unitsIds}/${formattedStart}/${formattedEnd}/${timescale}`,
    {
      headers: {
        'x-access-token': jwt,
      },
    },
  );

  if (response.data.kpi.length > 0) {
    const average = calculateAveragekpiByUnit(
      unitsIds,
      response.data.kpi,
      start,
      end,
      timescale,
    );
    yield put(
      getKpisSuccess({
        kpis: response.data.kpi,
        averages: average.kpis,
        labels: average.labels,
      }),
    );
  } else {
    yield put(getKpisFailure(response.data.kpi));
  }
}

export default all([takeLatest(ActionTypes.getKpisRequest, getKpis)]);
